export const DASHBOARD = '/';
export const PROJECTS = '/projects';
export const CREATE_PROJECT = `${PROJECTS}/create`;
export const EDIT_PROJECT = `${PROJECTS}/edit`;
export const CREATE_PAYMENT = '/create-payment';
export const INVOICES = '/invoices';
export const CREATE_INVOICES = `${INVOICES}/create`;
export const DRAFT_INVOICE = `${INVOICES}/draft`;
export const TALENT = '/talent';
export const PROFILE = '/profile';
export const LIBRARY = '/library';
export const CREATE_DOCUMENT = '/create-document';
export const REPORTING = '/reporting';
export const BULK_UPLOAD = '/bulk-upload';
export const RESET_PASSWORD = '/reset-password';
export const ADMINISTRATION = '/administration';
export const ADMINISTRATION_MANAGERS = `${ADMINISTRATION}/managers`;
export const ADMINISTRATION_MANAGERS_CREATE = `${ADMINISTRATION}/create`;
export const ADMINISTRATION_MANAGERS_EDIT = `${ADMINISTRATION}/edit`;
export const ADMINISTRATION_COMPANIES = `${ADMINISTRATION}/companies`;
export const ADMINISTRATION_COMPANIES_CREATE = `${ADMINISTRATION_COMPANIES}/create`;
export const ADMINISTRATION_COMPANIES_EDIT = `${ADMINISTRATION_COMPANIES}/edit`;
export const ADMINISTRATION_TALENT = `${ADMINISTRATION}/talent`;
export const ADMINISTRATION_TALENT_CREATE = `${ADMINISTRATION_TALENT}/create`;
export const ADMINISTRATION_TALENT_EDIT = `${ADMINISTRATION_TALENT}/edit`;
